export default {
  "preview.header": "プレビュー画面:",
  "preview.link.ja": "日本語",
  "preview.link.en": "英語",
  "preview.link.bbt": "BBT",
} as const;
